import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=13b80859&scoped=true"
import script from "./EditorHeader.vue?vue&type=script&lang=js"
export * from "./EditorHeader.vue?vue&type=script&lang=js"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=13b80859&prod&lang=css"
import style1 from "./EditorHeader.vue?vue&type=style&index=1&id=13b80859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b80859",
  null
  
)

export default component.exports